export const ActionsButtonStyleValues = { width: '9.45rem' }
